export const version = '12.7.1';
export const buildDate = '2025-06-22T14:31:38.436Z';
export const commitHash = '90f156b';